import { styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import WarningIcon from '@mui/icons-material/Warning';
import EditIcon from '@mui/icons-material/Edit';
import ErrorIcon from '@mui/icons-material/Error';
import PauseIcon from '@mui/icons-material/Pause';
import SendIcon from '@mui/icons-material/Send';

const statusConfig = {
  ativo: {
    bg: '#DCFCE7',
    border: '1px solid #86EFAC',
    text: '#14532D',
    icon: <CheckCircleIcon style={{ color: '#14532D' }} />,
  },
  aprovado: {
    bg: '#DCFCE7',
    border: '1px solid #86EFAC',
    text: '#14532D',
    icon: <CheckCircleIcon style={{ color: '#14532D' }} />,
  },
  pago: {
    bg: '#DCFCE7',
    border: '1px solid #86EFAC',
    text: '#14532D',
    icon: <CheckCircleIcon style={{ color: '#14532D' }} />,
  },
  em_análise: {
    bg: '#FEF3C7',
    border: '1px solid #FCD34D',
    text: '#78350F',
    icon: <HourglassBottomIcon style={{ color: '#78350F' }} />,
  },
  em_análise_financeiro: {
    bg: '#FEF3C7',
    border: '1px solid #FCD34D',
    text: '#78350F',
    icon: <HourglassBottomIcon style={{ color: '#78350F' }} />,
  },
  em_análise_gestor: {
    bg: '#C9A7E8',
    border: '1px solid #68408F',
    text: '#3F1D6B',
    icon: <HourglassBottomIcon style={{ color: '#3F1D6B' }} />,
  },
  pendente: {
    bg: '#FEF3C7',
    border: '1px solid #FCD34D',
    text: '#78350F',
    icon: <HourglassBottomIcon style={{ color: '#78350F' }} />,
  },
  aguardando_pagamento: {
    bg: '#FEF3C7',
    border: '1px solid #FCD34D',
    text: '#78350F',
    icon: <HourglassBottomIcon style={{ color: '#78350F' }} />,
  },
  análise_do_gerente: {
    bg: '#FEF3C7',
    border: '1px solid #FCD34D',
    text: '#78350F',
    icon: <HourglassBottomIcon style={{ color: '#78350F' }} />,
  },
  pendência_do_fornecedor: {
    bg: '#FEE2E2',
    border: '1px solid #FCA5A5',
    text: '#7F1D1D',
    icon: <WarningIcon style={{ color: '#7F1D1D' }} />,
  },
  pendencia_do_fornecedor: {
    bg: '#FEE2E2',
    border: '1px solid #FCA5A5',
    text: '#7F1D1D',
    icon: <WarningIcon style={{ color: '#7F1D1D' }} />,
  },
  pendência_gestor: {
    bg: '#FEE2E2',
    border: '1px solid #FCA5A5',
    text: '#7F1D1D',
    icon: <WarningIcon style={{ color: '#7F1D1D' }} />,
  },
  pendência: {
    bg: '#FEE2E2',
    border: '1px solid #FCA5A5',
    text: '#7F1D1D',
    icon: <WarningIcon style={{ color: '#7F1D1D' }} />,
  },
  cancelado: {
    bg: '#FEE2E2',
    border: '1px solid #FCA5A5',
    text: '#7F1D1D',
    icon: <WarningIcon style={{ color: '#7F1D1D' }} />,
  },
  rascunho: {
    bg: '#E8B77D',
    border: '1px solid #8A4700',
    text: '#5C2A00',
    icon: <EditIcon style={{ color: '#5C2A00' }} />,
  },
  vencido: {
    bg: '#FFE4E6',
    border: '1px solid #FDA4AF',
    text: '#7F1D1D',
    icon: <ErrorIcon style={{ color: '#7F1D1D' }} />,
  },
  erro_no_pagamento: {
    bg: '#FFE4E6',
    border: '1px solid #FDA4AF',
    text: '#7F1D1D',
    icon: <ErrorIcon style={{ color: '#7F1D1D' }} />,
  },
  erro: {
    bg: '#FFE4E6',
    border: '1px solid #FDA4AF',
    text: '#7F1D1D',
    icon: <ErrorIcon style={{ color: '#7F1D1D' }} />,
  },
  documento_cancelado: {
    bg: '#FFE4E6',
    border: '1px solid #FDA4AF',
    text: '#7F1D1D',
    icon: <ErrorIcon style={{ color: '#7F1D1D' }} />,
  },
  enviado: {
    bg: '#F3F4F6',
    border: '1px solid #D1D5DB',
    text: '#374151',
    icon: <SendIcon style={{ color: '#374151' }} />,
  },
};

const fallbackConfig = {
  bg: '#F3F4F6',
  border: '1px solid #D1D5DB',
  text: '#374151',
  icon: <PauseIcon style={{ color: '#374151' }} />,
};

const StyledChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'status',
})(({ status }) => {
  const config =
    statusConfig[status?.toLowerCase().replaceAll(' ', '_')] || fallbackConfig;

  return {
    backgroundColor: config.bg,
    color: config.text,
    border: config.border,
  };
});

const CustomChip = ({ status, label, ...props }) => {
  const currentConfig =
    statusConfig[status?.toLowerCase().replaceAll(' ', '_')] || fallbackConfig;

  return (
    <StyledChip
      status={status}
      label={label ? label.toUpperCase() : label}
      icon={currentConfig.icon}
      {...props}
    />
  );
};

export default CustomChip;
